// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__YeZ6C","sidebar__wrapper":"Sidebar_sidebar__wrapper__LVBMd","sidebar__support":"Sidebar_sidebar__support__UnUhf"};